import React from 'react';

const Services: React.FC = () => {
  const services = [
    {
      title: "Being Authentically You",
      description: "Discover how to authentically show up as yourself while meeting professional expectations and overcoming imposter syndrome.",
      icon: "",
      features: ["Authentic Self-Expression", "Overcoming Imposter Syndrome", "Values Alignment", "Confidence Building"]
    },
    {
      title: "Work-Life Harmony",
      description: "Create sustainable boundaries that honor both your personal identity and professional ambitions without sacrifice.",
      icon: "",
      features: ["Boundary Setting", "Energy Management", "Role Transition", "Personal Fulfillment"]
    },
    {
      title: "Influence & Impact",
      description: "Learn to lead with your authentic voice while building genuine influence and creating meaningful professional relationships.",
      icon: "",
      features: ["Authentic Leadership", "Relationship Building", "Communication Style", "Personal Brand"]
    },
    {
      title: "Private & Group-Led Artist's Way Workshops",
      description: "Reconnect with your creativity through Julia Cameron's The Artist's Way — offered as private sessions or intimate, group-led cohorts.",
      icon: "",
      features: ["Private & Group Formats", "12-Week Creative Recovery", "Weekly IRL Community", "Unblock Your Inner Artist"]
    }
  ];

  return (
    <section className="section bg-gray-50">
      <div className="container">
        <div className="text-center" style={{ marginBottom: '64px' }}>
          <h2 id="services" className="section-title" style={{ paddingTop: '120px', marginTop: '-100px' }}>
            What is Persona Coaching?
          </h2>
          <div className="section-subtitle" style={{ maxWidth: '900px', margin: '0 auto' }}>
            <p style={{ fontSize: '1.25rem', marginBottom: '20px', fontWeight: '500' }}>
              A persona coach helps you navigate and embody different roles with <strong>authentic confidence</strong>.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', marginTop: '24px' }}>
              <div>
                <h4 style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--primary-green)', marginBottom: '12px' }}>What I Help With:</h4>
                <ul style={{ listStyle: 'none', padding: 0, fontSize: '1rem', lineHeight: '1.6' }}>
                  <li style={{ marginBottom: '8px' }}>• Transitioning between professional "hats"</li>
                  <li style={{ marginBottom: '8px' }}>• Authentic self-presentation</li>
                  <li style={{ marginBottom: '8px' }}>• Overcoming role-based anxiety</li>
                </ul>
              </div>
              <div>
                <h4 style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--primary-green)', marginBottom: '12px' }}>My Approach:</h4>
                <ul style={{ listStyle: 'none', padding: 0, fontSize: '1rem', lineHeight: '1.6' }}>
                  <li style={{ marginBottom: '8px' }}>• Performance techniques</li>
                  <li style={{ marginBottom: '8px' }}>• Mindset strategies</li>
                  <li style={{ marginBottom: '8px' }}>• Practical tools & exercises</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="text-center" style={{ marginTop: '32px' }}>
            <a href="#contact" className="btn btn-primary" style={{ fontSize: '18px', padding: '16px 32px' }}>
              Book Free Consultation
            </a>
          </div>
        </div>
        
        <div className="card" style={{ padding: '48px', marginBottom: '64px', backgroundColor: 'white' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h3 style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--gray-900)', marginBottom: '16px' }}>Is this for me?</h3>
            <p style={{ fontSize: '1.25rem', color: 'var(--primary-green)', fontWeight: '500' }}>
              If any of these resonate, persona coaching can help:
            </p>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '32px', marginBottom: '40px' }}>
            <div style={{ textAlign: 'center', padding: '24px', border: '2px solid var(--gray-200)', borderRadius: '12px' }}>
              <div style={{ width: '48px', height: '48px', backgroundColor: 'var(--primary-green)', borderRadius: '50%', margin: '0 auto 16px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: 'white' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
                  <rect width="8" height="4" x="8" y="2" rx="1" ry="1"/>
                  <path d="M12 11h4"/>
                  <path d="M12 16h4"/>
                  <path d="M8 11h.01"/>
                  <path d="M8 16h.01"/>
                </svg>
              </div>
              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '12px' }}>Imposter Syndrome</h4>
              <p style={{ fontSize: '0.95rem', color: 'var(--gray-600)', lineHeight: '1.5' }}>Feel like you don't belong in professional settings</p>
            </div>
            <div style={{ textAlign: 'center', padding: '24px', border: '2px solid var(--gray-200)', borderRadius: '12px' }}>
              <div style={{ width: '48px', height: '48px', backgroundColor: 'var(--primary-green)', borderRadius: '50%', margin: '0 auto 16px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: 'white' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                </svg>
              </div>
              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '12px' }}>Self-Doubt</h4>
              <p style={{ fontSize: '0.95rem', color: 'var(--gray-600)', lineHeight: '1.5' }}>Question your abilities across different roles</p>
            </div>
            <div style={{ textAlign: 'center', padding: '24px', border: '2px solid var(--gray-200)', borderRadius: '12px' }}>
              <div style={{ width: '48px', height: '48px', backgroundColor: 'var(--primary-green)', borderRadius: '50%', margin: '0 auto 16px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: 'white' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
                  <path d="M8 12h8"/>
                  <path d="M12 8v8"/>
                  <circle cx="8" cy="8" r="2"/>
                  <circle cx="16" cy="8" r="2"/>
                  <circle cx="8" cy="16" r="2"/>
                  <circle cx="16" cy="16" r="2"/>
                </svg>
              </div>
              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '12px' }}>Role Disconnect</h4>
              <p style={{ fontSize: '0.95rem', color: 'var(--gray-600)', lineHeight: '1.5' }}>Feel fragmented between life aspects</p>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', backgroundColor: 'var(--gray-50)', padding: '32px', borderRadius: '12px' }}>
            <h4 style={{ fontSize: '1.25rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '16px' }}>The Solution</h4>
            <p style={{ fontSize: '1.1rem', color: 'var(--gray-700)', lineHeight: '1.6', maxWidth: '600px', margin: '0 auto' }}>
              Explore, understand, and <strong>integrate your personas</strong> in alignment with your authentic self. Navigate challenges, unlock potential, and present confidently in all areas of life.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-3" style={{ marginBottom: '80px' }}>
          {services.map((service, index) => (
            <div key={index} className="card text-center">
              <div style={{ width: '60px', height: '60px', backgroundColor: 'var(--primary-green)', borderRadius: '50%', margin: '0 auto 20px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', color: 'white', fontWeight: 'bold' }}>{index + 1}</div>
              <h3 className="card-title">{service.title}</h3>
              <p className="card-description" style={{ marginBottom: '24px' }}>{service.description}</p>
              <div style={{ textAlign: 'left' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '600', color: 'var(--gray-700)', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Key Areas:</h4>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {service.features.map((feature, i) => (
                    <li key={i} style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      marginBottom: '8px',
                      fontSize: '14px',
                      color: 'var(--gray-600)'
                    }}>
                      <span style={{ 
                        width: '6px', 
                        height: '6px', 
                        backgroundColor: 'var(--primary-green)', 
                        borderRadius: '50%', 
                        marginRight: '12px'
                      }}></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;